import moment from 'moment';

const USDformatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
const doRounding = true;
const dashedZeros = true;
const accountantNeg = true;

let exchangeRate = 1.00;

function parseFloatWithZero(value) {
  let floatVal = parseFloat(value);
  return isNaN(floatVal) ? 0 : floatVal;
}

function parseFloatWithZeroConv(value) {
  return parseFloatWithZero(value) * exchangeRate;
}

export default {
  trimmedString(val) {
    return val ? val.trim() : val;
  },

  setExchangeRate(rate) {
    exchangeRate = rate;
  },
  
  toCurrencyString(value) {
    if (isNaN(value)) {
      value = 0;
    }

    if (doRounding) {
      value = Math.round(value);
    }

    let formattedValue = USDformatter.format(value);

    if (dashedZeros && value === 0) {
      formattedValue = "$ -";
    }
    else {
      if (doRounding) {
        formattedValue = formattedValue.substring(0, formattedValue.length - 3);
      }

      if (accountantNeg) {
        if (formattedValue.startsWith('-')) {
          formattedValue = `(${formattedValue.substring(1)})`;
        }
      }
    }

    return formattedValue;
  },

  toExcelCurrencyString(value) {
    let returnVal = 0;

    if (!isNaN(value)) {
      returnVal = Math.round(value);
    }

    return returnVal;
  },

  toPercentString(value) {
    if (!isNaN(value) && value !== -Infinity) {
      if (doRounding) {
        value = Math.round(value);
      }
    }
    else {
      value = '- ';
    }

    return `${value}%`;
  },

  sytelineDateToMoment(sytelineDate) {
    return moment(sytelineDate, 'YYYYMMDD HH:mm:ss.SSS');
  },

  truncateDecimals(amount) {
    let pieces = amount.split('.');
    if (pieces.length === 2) {
      return `${pieces[0]}.${pieces[1].substring(0, 2)}`;
    }
    else {
      return amount;
    }
  },

  parseFloatWithZero: parseFloatWithZero,
  
  parseFloatWithZeroConv: parseFloatWithZeroConv,

  costCodeToIndex(costCode) {
    let trimmedCostCode = costCode.trim();
    if (trimmedCostCode.length === 2) {
      trimmedCostCode = '0' + trimmedCostCode;
    }

    trimmedCostCode = trimmedCostCode.substring(0, trimmedCostCode.length - 2);
    if (trimmedCostCode) {
      return parseInt(trimmedCostCode);
    }

    return null;
  },
  
  poStatToDesc(val) {
    if (val === 'O') return 'Ordered';
    if (val === 'F') return 'Filled';
    if (val === 'P') return 'Planned';
    return val;
  },

  costCodeDescriptions: [
    'Project Mgmnt.',
    'Mechanical Components',
    'Electrical Components',
    'Major Purchases',
    'Production Labor',
    'Engineering',
    'Installation Materials',
    'Mechanical Installation',
    'Electrical Installation',
    'Site Supervision',
  ]
}